import type {
  PublicPlayerDealResponse,
  PublicPlayerDealResponsePagedData,
} from '@on3/api';
import { On3IconMessage } from '@on3/icons';
import { SocialIcon } from '@on3/ui-lib/components/SocialIcon';
import { getAssetUrl } from '@on3/ui-lib/utils/images';
import { Link } from '@public/components/Link';
import { getSocialFromUrl } from '@public/utils/social';
import { format } from 'date-fns';
import { useRouter } from 'next/router';

import styles from './PlayerNilDeals.module.scss';

interface IPlayerNilDealsProps {
  playerDeals?: PublicPlayerDealResponsePagedData | null;
  showAll?: boolean;
}
export const PlayerNilDeals = ({
  playerDeals,
  showAll = false,
}: IPlayerNilDealsProps) => {
  const { id } = useRouter().query;
  const { list = [] } = playerDeals || {};
  const deals = showAll ? list : list?.slice(0, 3);

  return (
    <div className={styles.block}>
      <table>
        <thead>
          <tr>
            <th id="date">Date</th>
            <th id="partners">Deal Partners</th>
            <th id="details">Details</th>
          </tr>
        </thead>
        <tbody>
          {deals?.length ? (
            deals?.map((deal: PublicPlayerDealResponse) => {
              const name = deal.company?.name ?? deal.collectiveGroup?.name;
              const href =
                deal.company?.url ??
                (deal.collectiveGroup?.slug &&
                  `/nil/collectives/${deal.collectiveGroup?.slug}/`);
              const assetUrl =
                deal.company?.assetUrl ??
                getAssetUrl(deal.collectiveGroup?.defaultAsset);

              return (
                <tr key={deal.key}>
                  <td headers="date">
                    {format(new Date(deal.date as string), 'M/dd/yy')}
                  </td>
                  <td headers="partners">
                    <Link href={href}>
                      {name}
                      {assetUrl && <img alt={name} src={assetUrl} />}
                    </Link>
                  </td>
                  <td headers="details">
                    <div>
                      {deal.detail?.fullUrl && (
                        <Link href={deal.detail?.fullUrl}>
                          <On3IconMessage />
                        </Link>
                      )}
                      {deal.detail?.title}
                    </div>
                  </td>
                  <td headers="source">
                    {deal.sourceUrl && (
                      <div>
                        <Link href={deal.sourceUrl}>
                          <SocialIcon type={getSocialFromUrl(deal.sourceUrl)} />
                          Source
                        </Link>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={3} data-status="no-results">
                No deals found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {!showAll && list?.length > 3 && (
        <footer>
          <Link href={`/rivals/${id}/nil-deals/`}>View all</Link>
        </footer>
      )}
    </div>
  );
};
